import * as f from "react";
import { g as C, c as E } from "./generateUtilityClass-DMFG5-Cu.mjs";
import { u as I, F as P } from "./useFormControl-C9UMlaFq.mjs";
import { m as A } from "./memoTheme-BzXKG_-k.mjs";
import { g as S } from "./generateUtilityClasses-CWIIr9E_.mjs";
import { j as r } from "./jsx-runtime-3tyXYecC.mjs";
import { s as j, u as L, c as R } from "./DefaultPropsProvider-CFfEbxdP.mjs";
import { T as w } from "./Typography-DfkimCSn.mjs";
import { c as m } from "./tss-DN0acMKN.mjs";
function z(t) {
  return C("MuiInputAdornment", t);
}
const h = S("MuiInputAdornment", ["root", "filled", "standard", "outlined", "positionStart", "positionEnd", "disablePointerEvents", "hiddenLabel", "sizeSmall"]);
var g;
const F = (t, e) => {
  const {
    ownerState: o
  } = t;
  return [e.root, e[`position${m(o.position)}`], o.disablePointerEvents === !0 && e.disablePointerEvents, e[o.variant]];
}, T = (t) => {
  const {
    classes: e,
    disablePointerEvents: o,
    hiddenLabel: i,
    position: n,
    size: a,
    variant: l
  } = t, p = {
    root: ["root", o && "disablePointerEvents", n && `position${m(n)}`, l, i && "hiddenLabel", a && `size${m(a)}`]
  };
  return R(p, z, e);
}, $ = j("div", {
  name: "MuiInputAdornment",
  slot: "Root",
  overridesResolver: F
})(A(({
  theme: t
}) => ({
  display: "flex",
  maxHeight: "2em",
  alignItems: "center",
  whiteSpace: "nowrap",
  color: (t.vars || t).palette.action.active,
  variants: [{
    props: {
      variant: "filled"
    },
    style: {
      [`&.${h.positionStart}&:not(.${h.hiddenLabel})`]: {
        marginTop: 16
      }
    }
  }, {
    props: {
      position: "start"
    },
    style: {
      marginRight: 8
    }
  }, {
    props: {
      position: "end"
    },
    style: {
      marginLeft: 8
    }
  }, {
    props: {
      disablePointerEvents: !0
    },
    style: {
      pointerEvents: "none"
    }
  }]
}))), q = /* @__PURE__ */ f.forwardRef(function(e, o) {
  const i = L({
    props: e,
    name: "MuiInputAdornment"
  }), {
    children: n,
    className: a,
    component: l = "div",
    disablePointerEvents: p = !1,
    disableTypography: b = !1,
    position: c,
    variant: u,
    ...x
  } = i, s = I() || {};
  let d = u;
  u && s.variant, s && !d && (d = s.variant);
  const v = {
    ...i,
    hiddenLabel: s.hiddenLabel,
    size: s.size,
    disablePointerEvents: p,
    position: c,
    variant: d
  }, y = T(v);
  return /* @__PURE__ */ r.jsx(P.Provider, {
    value: null,
    children: /* @__PURE__ */ r.jsx($, {
      as: l,
      ownerState: v,
      className: E(y.root, a),
      ref: o,
      ...x,
      children: typeof n == "string" && !b ? /* @__PURE__ */ r.jsx(w, {
        color: "textSecondary",
        children: n
      }) : /* @__PURE__ */ r.jsxs(f.Fragment, {
        children: [c === "start" ? (
          /* notranslate needed while Google Translate will not fix zero-width space issue */
          g || (g = /* @__PURE__ */ r.jsx("span", {
            className: "notranslate",
            children: "​"
          }))
        ) : null, n]
      })
    })
  });
});
export {
  q as I
};
//# sourceMappingURL=InputAdornment-T4xPPRnD.mjs.map
